import { ImageComponent, SpanTag, Spinner } from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { theme } from "@tm/utility/global";
import React from "react";
import { BtnProp } from "./ButtonType";
import { LandingButtonStyle, ShimmerWrap } from "./LandingButton.style";

const LandingButton = ({
  customTitle,
  margin,
  customWidth,
  disableState,
  onClick,
  flexShrink,
  shimmerBtn,
  flex,
  customHeight,
  btnLeftIcon,
  btnRightIcon,
  fontSize,
  isLoading,
  buttonref,
  letterSpacing,
}: BtnProp) => {
  const context = usePartnerContext();

  return (
    <LandingButtonStyle
      ref={buttonref}
      onClick={onClick}
      customWidth={customWidth}
      margin={margin}
      customHeight={customHeight}
      flexShrink={flexShrink}
      flex={flex}
      fontSize={fontSize}
      letterSpacing={letterSpacing}
      disableState={disableState}
      btnTheme={context ? context : undefined}
      txtClipIcon={btnLeftIcon !== "" && btnRightIcon !== ""}
    >
      {isLoading ? (
        <Spinner spinnerColor={"#fff"} />
      ) : (
        <React.Fragment>
          {btnLeftIcon && (
            <ImageComponent width="24px" height="24px" src={btnLeftIcon} />
          )}
          {customTitle && (
            <SpanTag color={theme.blueText} fontSize="md" fontWeight="black">
              {customTitle}
            </SpanTag>
          )}
          {shimmerBtn && (
            <ShimmerWrap>
              <img src="../../../images/shimmerBtn.svg" />
            </ShimmerWrap>
          )}
          {btnRightIcon && (
            <ImageComponent
              width="16px"
              height="16px"
              margin="0 0 0 auto"
              src={btnRightIcon}
            />
          )}
        </React.Fragment>
      )}
    </LandingButtonStyle>
  );
};

export default LandingButton;
